module.exports = __webpack_public_path__ + "static/media/leadBundle.42362f2a.svg";